import {
	Component,
	OnInit,
	HostBinding,
	Output,
	EventEmitter,
	Input,
	Inject,
	ViewChild,
	ElementRef
} from '@angular/core';
import { IconList } from '../../icon-list';
import { MatSlideToggleChange, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
export interface DialogData {
	icon: string;
	color: 'default' | 'warn' | 'accent' | 'safe' | 'primary';
}
@Component({
	selector: 'common-icon-select',
	templateUrl: './icon-select.component.html',
	styleUrls: ['./icon-select.component.scss']
})
export class IconSelectComponent implements OnInit {
	@HostBinding('class.icon-select') hostClass = true;
	@ViewChild('å¾æ éæ©', { static: true })
	å¾æ éæ©: ElementRef;
	nameSpace: string;
	iconName: string;
	iconCategoryCN = 'ç¼è¾ç±»';
	constructor(
		public iconList: IconList,
		public dialogRef: MatDialogRef<IconSelectComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData
	) {
		this.icon(this.data.icon);
	}

	ngOnInit() {
		this.å¾æ éæ©.nativeElement.parentElement.parentElement.style = 'padding:0px;';
	}
	check(event: MatSlideToggleChange) {
		if (event.checked) {
			this.nameSpace = 'outlined';
		} else {
			this.nameSpace = '';
		}
	}
	categories() {
		return this.iconList.icons[this.nameSpace];
	}
	ok() {
		return {
			icon: this.nameSpace ? this.nameSpace + ':' + this.iconName : this.iconName,
			color: this.data.color
		};
	}
	icon(val: string) {
		console.log(val);
		if (val) {
			const ns = val.split(':');
			if (ns.length > 1) {
				this.nameSpace = ns[0];
				this.iconName = ns[1];
			} else {
				this.nameSpace = '';
				this.iconName = ns[0];
			}
		} else {
			this.nameSpace = '';
		}
	}
}
